module.exports = __webpack_public_path__ + "img/logo_fesicol.71fe7a8.png";